import {Component, Input, OnInit} from "@angular/core";
import {IconThemeEnum, IconThemeLabel} from "./icon-theme-enum";

@Component({
    selector: 'yo-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    standalone: false
})
export class IconComponent implements OnInit {

  // à supprimer en attendant la refonte complète des boutons
  @Input() cssClass: string;

  @Input() theme: IconThemeEnum = IconThemeEnum.DEFAULT_INNER;
  @Input() variant: "solid" | "regular" | "light" = "solid";
  @Input() icon: string;
  @Input() allowDefault: boolean = true;
  @Input() size: "large" | "default" | "small" = "default";

  ngOnInit(): void {
    this.initIcon()
  }

  initIcon = () => {
    if (!this.icon && this.allowDefault) {
      this.icon = "question";
    }

    if (this.allowDefault && this.icon.startsWith("fa-"))
      this.icon = this.icon.slice(3);
  }

  getVariante = () => {
    switch (this.variant) {
      case "light":
        return "fal";
      case "solid":
        return "fas";
      case "regular":
        return "far";
    }
  }

  getIconThemeLabel() {
    return IconThemeLabel[this.theme];
  }
}
